<div *ngIf="showTotal" class="calculation-field">
  <span class="calculation-label">
    {{ 'LABEL.TOTAL' | translate }}
  </span>

  <span class="amount">
    {{ documentCalculationResult?.total | money: currencyCode:locale }}
  </span>
</div>

<div *ngIf="showPaid" class="calculation-field">
  <span class="calculation-label">
    {{ 'LABEL.PAID' | translate }}
  </span>

  <span class="amount">
    {{
      documentCalculationResult?.amountPaidExcludingFees
        | money: currencyCode:locale
    }}
  </span>
</div>

<div
  [ngSwitch]="useOutstandingBalance"
  class="calculation-field calculation-highlight"
>
  <ng-container *ngSwitchCase="true">
    <span class="calculation-label">
      {{ 'LABEL.BALANCE' | translate }}
    </span>

    <span class="amount balance-amount" data-e2e-id="balance-amount">
      {{
        documentCalculationResult?.outstandingBalance
          | money: currencyCode:locale
      }}
    </span>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <span class="calculation-label">
      {{ 'LABEL.TOTAL' | translate }}
    </span>

    <span class="amount balance-amount">
      {{ documentCalculationResult?.totalPayable | money: currencyCode:locale }}
    </span>
  </ng-container>
</div>
